module.exports = {
  baseApi: process.env.VUE_APP_BASE_API || '/api/',
  SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN
}
